export const REFUNDS_REQUESTING = 'refunds/REQUESTING';
export const REFUNDS_SUCCESS = 'refunds/SUCCESS';
export const REFUNDS_ERROR = 'refunds/ERROR';
export const RESET_REFUNDS = 'refunds/RESET';
